export default __webpack_public_path__ + "static/media/defaultBackground.618f7dd6.svg";